export const DEFAULT_DROPDOWN_COMPOSITE_MAX_HEIGHT = 430;
export const XSMALL_DROPDOWN_COMPOSITE_MAX_HEIGHT = 370;
export const DROPDOWN_COMPOSITE_LIST_MIN_WIDTH = 180;
export const DEFAULT_DROPDOWN_COMPOSITE_FILTER_WITH_FILTER_MIN_HEIGHT = 106;
export const DEFAULT_DROPDOWN_COMPOSITE_FILTER_MIN_HEIGHT = 63;
export const DEFAULT_DROPDOWN_COMPOSITE_FILTER_MIN_WIDTH = 160;
export const DEFAULT_DROPDOWN_COMPOSITE_MULTI_SELECT_MAX_HEIGHT = 408;
